export default "__VITE_ASSET__hnMgextu__"